export function buildQueryParams(params: Record<string, string | string[] | number | number[] | boolean | boolean[] | undefined | null>): string {
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.join(','))}`
      }
      if (value !== undefined && value !== null && value !== '') {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      } else {
        return ''
      }
    })
    .join('&')

  return query ? `?${query}` : ''
}

export function toQueryParams<T extends object>(obj: T): string {
  const params: string[] = []

  function process(key: string, value: object) {
    if (value === null || value === undefined || (typeof value === 'string' && value === '')) {
      return
    }

    if (Array.isArray(value)) {
      if (value.length > 0) {
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.join(','))}`)
      }
    } else if (value instanceof Date) {
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.toISOString())}`)
    } else if (typeof value === 'object' && value !== null) {
      for (const [subKey, subValue] of Object.entries(value)) {
        process(subKey, subValue)
      }
    } else {
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
  }

  let current = obj
  do {
    for (const [key, value] of Object.entries(current)) {
      if (!params.some(param => param.startsWith(`${encodeURIComponent(key)}=`))) {
        process(key, value)
      }
    }
    current = Object.getPrototypeOf(current)
  } while (current && current !== Object.prototype)

  return params.join('&')
}
